import { SgwtMiniFooter } from '@sgwt/sgwt-widgets-react';

export const MiniFooter = () => (
  <div className="border-top">
    <div className="px-4 mx-2">
      <SgwtMiniFooter
        type="compact"
        design="light"
        mode="sg-markets"
        contactUsByHelpCenter="sgwt-help-center"
        noBorder
      />
    </div>
  </div>
);
